export function preRender(data, options) {
  const showOnHover = options.showTooltips;
  data.plotOptions.series = {
    // dataLabels: {
    //   enabled: true,
    //   formatter: function() {
    //     return this.point.value;
    //   }
    // },
    stickyTracking: false,
    marker: {
      symbol: 'circle',
      radius: 4,
      enabled: true,
      states: {
        hover: {
          enabled: showOnHover
        }
      }
    }
  };
  return data;
}


// WEBPACK FOOTER //
// ./src/chart/inner/chart-scatter.js